import PropTypes from 'prop-types';
import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import { NavLink } from 'react-router-dom';

class SmallBackground extends React.Component {

    render() {

        const { classes, width } = this.props;

        return (
            <div style={{
                backgroundColor: '#13294B',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                position: 'absolute',
                top: 0,
                width: '100%',
                height: '100%',
                zIndex: -1
            }}>
                <h1 style={{
                    position: 'absolute',
                    top: 50,
                    left: width !== "xs" ? 'calc(50% - 250px)' : '5%',
                    right: width !== "xs" ? 'calc(50% - 250px)' : '5%',
                    padding: 0,
                    color: 'white',
                    fontSize: '1.5rem',
                    fontWeight: 'normal'
                }}>
                    <NavLink to="/">
                        <img
                            data-test="home"
                            className={width === "xs" ? classes.largeLogoXS : classes.largeLogo}
                            src="/images/logo-reversed.png"
                            alt="Logo" />
                    </NavLink>
                    {width !== "xs" &&
                        <span style={{
                            fontFamily: 'Rajdhani',
                            fontSize: 24,
                            marginTop: 100,
                            display: 'block',
                            marginLeft: 160
                        }}>Knowledge graph management</span>
                    }
                </h1>
                {this.props.size !== "xs" && <img style={{ position: 'absolute', left: -100, top: 200, width: 360 }} src="/images/icon-reversed.png" alt="" />}
            </div>
        );
    }
}

SmallBackground.propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any,
    size: PropTypes.string,
    width: PropTypes.string
};

export default withWidth()(withStyles(styles)(SmallBackground));